import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo, useRef } from 'react'
import { fetchOrderCancellationConfigs } from 'actions/OrderActions'
import orderCancellationConfigMap from 'api/mappers/orderCancellationConfigMap'

function useOrderCancellationConfigs(id?: string, orderId?: string): [
  cancellationConfig: App.OrderItemHotelCancellationConfig,
  cancellationConfigLoading: boolean,
  cancellationConfigError: any,
] {
  const dispatch = useAppDispatch()

  const cancellationConfigs = useAppSelector(state =>
    orderId ? state.orders.cancellationConfigs[orderId] : undefined,
  )
  const fetching = useAppSelector(state =>
    orderId ? state.orders.cancellationConfigsFetching[orderId] : false,
  )
  const error = useAppSelector(state =>
    orderId ? state.orders.cancellationConfigsErrors[orderId] : undefined,
  )

  const forceRefetchAttempted = useRef(false)

  useEffect(() => {
    if (!orderId) return

    if (!cancellationConfigs) {
      forceRefetchAttempted.current = false
      dispatch(fetchOrderCancellationConfigs(orderId))
      return
    }
    if (id && !cancellationConfigs[id] && !fetching && !error && !forceRefetchAttempted.current) {
      forceRefetchAttempted.current = true
      dispatch(fetchOrderCancellationConfigs(orderId, { force: true }))
    }
  }, [orderId, id, cancellationConfigs, fetching, error, dispatch])

  const config = cancellationConfigs?.[id ?? '']

  const orderItemCancellationConfig = useMemo(() => orderCancellationConfigMap(config), [config])

  return [orderItemCancellationConfig, fetching || !config, error]
}

export default useOrderCancellationConfigs
